"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, CircleCheck, ShieldCheck, Wrench } from "lucide-react";
export default function AboutVisual() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: <ShieldCheck className="size-5 text-primary" />,
    title: "Autoridade Criativa",
    description: "Liderança técnica em cada etapa da sua produção audiovisual."
  }, {
    icon: <Wrench className="size-5 text-primary" />,
    title: "Infraestrutura de Ponta",
    description: "Equipamentos de última geração em um estúdio planejado."
  }];
  return <section data-section-id="235680" id="quem-somos" className="bg-background text-foreground py-20 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="space-y-4">
              <h3 className="text-primary font-default font-semibold tracking-wider uppercase text-sm">
                O Estúdio
              </h3>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground leading-tight">
                Mais que uma produtora, seu parceiro estratégico
              </h2>
              <p className="text-muted-foreground font-default text-lg leading-relaxed max-w-xl">
                Localizado no coração de Pinheiros, nosso estúdio foi concebido para ser o ponto de encontro entre a criatividade e a tecnologia. Oferecemos um ambiente controlado e sofisticado para marcas que buscam excelência visual e narrativa.
              </p>
              <p className="text-muted-foreground font-default text-lg leading-relaxed max-w-xl">
                Nossa equipe combina anos de experiência no mercado publicitário com uma visão moderna de produção, garantindo que cada projeto não seja apenas entregue, mas sim transformado em um ativo estratégico para o seu negócio.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-6 pt-4">
              {features.map((feature, i) => <div key={i} data-index={i} className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                    {feature.icon}
                    <h4 className="font-default font-semibold text-foreground">{feature.title}</h4>
                  </div>
                  <p className="text-sm text-muted-foreground font-default pl-7">
                    {feature.description}
                  </p>
                </div>)}
            </div>

            <div className="pt-6 flex flex-wrap gap-4">
              <Button asChild size="lg" className="font-default bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg">
                <Link to="https://itcmais.com/o-estudio/">
                  Conheça o Estúdio
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="font-default border-2 border-primary bg-transparent text-primary hover:bg-primary/5 rounded-lg">
                <Link to="https://itcmais.com/portfolio/">
                  Ver Portfólio
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 ease-out delay-200 ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-xl overflow-hidden shadow-2xl border border-border/50 aspect-[4/3] lg:aspect-auto lg:h-[600px]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/pinheiros_studio_interior.png" alt="Interior do estúdio em Pinheiros com iluminação profissional" className="w-full h-full object-cover" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
            </div>

            {}
            <Card className="absolute -bottom-6 -left-6 md:-bottom-10 md:-left-10 w-48 shadow-xl border-border/50 bg-background/95 backdrop-blur-sm animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-500 rounded-2xl">
              <CardContent className="p-6 flex flex-col items-center justify-center text-center gap-2">
                <div className="bg-primary/10 p-3 rounded-full">
                  <CircleCheck className="size-8 text-primary" />
                </div>
                <div className="space-y-1">
                  <p className="text-3xl font-default font-bold text-foreground">100%</p>
                  <p className="text-xs font-default font-medium text-muted-foreground uppercase tracking-wider">Comprometimento</p>
                </div>
              </CardContent>
            </Card>

            {}
            <div className="absolute -z-10 -top-8 -right-8 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
            <div className="absolute -z-10 -bottom-8 -right-8 w-64 h-64 bg-accent/5 rounded-full blur-3xl" />
          </div>

        </div>
      </div>
    </section>;
}